<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <div class="main_content">
            <section class="bread_crumb">
                <div class="container">
                    <ul>
                        <li><router-link v-bind:to="'/'">Home</router-link></li> 
                        <li>Mission</li>
                    </ul>
                </div>
            </section>
            <div class="mission_banner_wrapper custom-banner-section">
                <div class="about_main_image">
                    <img src="../../assets/images/mission.png" alt="mission" />

                    <div class="about_main_title">
                        <h4>MISSION</h4>
                    </div>
                </div>
                <div class="our_mission_list">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-6 col-lg-7 col-md-9">
                                <ul class="mission_steps_list">
                                    <li>
                                        <div class="list_block">
                                            <div class="circle_image_wrap">
                                                <img src="../../assets/images/icon1.png">
                                            </div>
                                            <p>Provide top valued- CPD
                                            educational programs
                                            to our healthcare society</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="list_block">
                                            <div class="circle_image_wrap">
                                                <img src="../../assets/images/icon2.png">
                                            </div>
                                            <p>Develop efficient digital
                                            health solutions for small
                                            to medium size healthcare
                                            facilities</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="list_block">
                                            <div class="circle_image_wrap">
                                                <img src="../../assets/images/icon3.png">
                                            </div>
                                            <p>Promote quality practice for
                                            better health</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="list_block">
                                            <div class="circle_image_wrap">
                                                <img src="../../assets/images/icon4.png">
                                            </div>
                                            <p>Partner in Saudi Vision
                                            2030 - healthcare</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import AboutSideBar from './AboutSideBar'
import router from '../../router'


export default{
    data(){
        return {
            current_locale:this.$i18n_global.locale
        }
    },
    components:{
        HeaderMenu:HeaderMenu,
        AboutSideBar:AboutSideBar
    },
    methods:{
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/Mission.vue